import React, { useEffect, useState } from 'react'

import Modal from 'components/common/Modal'
import Input from 'components/common/Input'
import Button from 'components_new/atoms/Button'

const ManageApiKey = ({ value, onClose, onSave }) => {
  const [name, setName] = useState(value?.name || '')

  useEffect(() => {
    setName(value?.name || '')
  }, [value])

  return (
    <Modal
      header={value && value.name ? 'Redigera nyckel' : 'Generera nyckel'}
      visible={value}
      onClose={() => onClose()}
      actions={
        <>
          <Button onClick={() => onClose()} variant="text">
            Avbryt
          </Button>
          <Button
            colored
            onClick={async () => {
              onSave(name)
              setName('')
              onClose()
            }}
          >
            {value && value.name ? 'Spara' : 'Generera'}
          </Button>
        </>
      }
    >
      <Input
        size="large"
        label={'Namnge nyckel'}
        value={name}
        onChange={(e) => setName(e)}
      />
    </Modal>
  )
}

export default ManageApiKey
